import React from 'react';
import { Badge } from '@/components/ui/badge';
import type { PreRegistrationStatus, PreRegistrationStatusCode } from '../types/pre-registration.types';

const STATUS_CLASSES: Record<PreRegistrationStatusCode, string> = {
  pending_review: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  to_regularize: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
  already_registered: 'bg-green-100 text-green-800 hover:bg-green-100',
  regularized: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-100',
  deleted: 'bg-gray-200 text-gray-600 hover:bg-gray-200',
};

interface PreRegistrationStatusBadgeProps {
  status: PreRegistrationStatus;
}

export const PreRegistrationStatusBadge: React.FC<PreRegistrationStatusBadgeProps> = ({ status }) => (
  <Badge variant="secondary" className={`whitespace-nowrap ${STATUS_CLASSES[status.code]}`}>
    {status.name}
  </Badge>
);
